import { Breadcrumb, BreadcrumbItem } from "flowbite-react";
import { HiHome, HiFilter } from "react-icons/hi";
import { useEffect, useRef, useState } from "react";
import Loader from "../../Components/Loader/Loader";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getCookie } from "../../reducer/utils";
import LiveOTTCategoryFilter from "../../Components/SideFilters/LiveOTTCategoryFilter";

function LiveOTTCategory() {

  const baseURL = process.env.REACT_APP_BASE_URL;

  const toastId = useRef(null);

  const [showCategoryFilter, setShowCategoryFilter] = useState(false);
  const [fetchingCategories, setFetchingCategories] = useState(false);
  const [categories, setCategories] = useState([]);

  const [filter, setFilter] = useState({});

  const onApplyFilter = (filter_payload) => {
    const localFilter = {}
    console.log("filter_payload", filter_payload);

    if (filter_payload.subscription !== null) {
      localFilter.subscribed = filter_payload.subscription;
    }

    if (filter_payload.providerFilter !== undefined) {
      const providerNames = Object.keys(filter_payload.providerFilter).filter(key => filter_payload.providerFilter[key]);
      if (providerNames.length > 0) {
        localFilter.provider_name = {
          in_list: providerNames
        };
      }
    }

    setFilter(localFilter);
  }
  


  const updateCategorySubscriptionStatusLocal = (category_name, is_subscribed) => {
    const updatedCategories = categories.map(category => {
      if (category.category_name === category_name) {
        return { ...category, is_subscribed };
      }
      return category;
    });
    setCategories(updatedCategories);
  }

  const getCategories = async () => {
    toastId.current = toast.loading('Fetching categories...');

    const response = await fetch(`${baseURL}/api/v4/live-ott/category/filter`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${getCookie("token")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(filter)
    });
    if (!response.ok) {
      // Keep categories as an array on error (e.g. 403) so .map doesn't crash.
      setCategories([]);
      toast.update(toastId.current, {
        render:
          response.status === 401 || response.status === 403
            ? 'Session expired. Please log in again.'
            : 'Failed to fetch categories',
        type: 'error',
        isLoading: false,
        autoClose: 2000,
      });
      return;
    }

    const data = await response.json();
    setCategories(data?.['categories'] ?? []);

    toast.update(toastId.current, {
      render: 'Categories fetched successfully',
      type: 'success',
      isLoading: false,
      autoClose: 1000,
    });
  }

  const handleSubscribe = async (category_name) => {
    toastId.current = toast.loading('Subscribing to category...');
    const response = await fetch(`${baseURL}/api/v4/live-ott/category/${category_name}/subscribe`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${getCookie("token")}`,
        "Content-Type": "application/json",
      },
    });
    if(response.status === 201) {
      toast.update(toastId.current, {
        render: 'Category subscribed successfully',
        type: 'success',
        isLoading: false,
        autoClose: 1000,
      });
      updateCategorySubscriptionStatusLocal(category_name, true);
    }
    else {
      toast.update(toastId.current, {
        render: 'Failed to subscribe to category',
        type: 'error',
        isLoading: false,
        autoClose: 1000,
      });
    }
  }

  const handleUnsubscribe = async (category_name) => {
    toastId.current = toast.loading('Unsubscribing from category...');
    const response = await fetch(`${baseURL}/api/v4/live-ott/category/${category_name}/unsubscribe`, {
      method: "DELETE",
      headers: {
        "Authorization": `Bearer ${getCookie("token")}`,
        "Content-Type": "application/json",
      },
    });
    if(response.status === 204) {
      toast.update(toastId.current, {
        render: 'Category unsubscribed successfully',
        type: 'success',
        isLoading: false,
        autoClose: 1000,
      });
      updateCategorySubscriptionStatusLocal(category_name, false);
    }
    else {
      toast.update(toastId.current, {
        render: 'Failed to unsubscribe from category',
        type: 'error',
        isLoading: false,
        autoClose: 1000,
      });
    }
  }

  useEffect(() => {
    getCategories();
  }, [filter]);

  return (
    <>
      <ToastContainer />

      <LiveOTTCategoryFilter showCategoryFilter={showCategoryFilter} setShowCategoryFilter={setShowCategoryFilter} onApplyFilter={onApplyFilter} />

      {
        fetchingCategories && <Loader />
      }

      <div className="bg-white px-4 py-4 rounded-lg border-solid border-2 border-grey1 flex items-center justify-between">
        <Breadcrumb aria-label="Default breadcrumb example">
          <BreadcrumbItem href="/dashboard" icon={HiHome} />
          <BreadcrumbItem className='text-primary1'>Home</BreadcrumbItem>
        </Breadcrumb>
      </div>

      <div class="p-6 bg-white rounded-lg shadow-md mt-4">

        <div class="flex justify-between items-center mb-4">
          <h2 class="text-lg font-semibold">Live OTT Categories</h2>
          <div class="flex space-x-2">

            <button class="flex items-center border rounded-md px-4 py-2 gap-2" onClick={() => setShowCategoryFilter(true)}>
              <HiFilter />
              <span class="mr-2">Filter</span>
            </button>

          </div>
        </div>


        <div class="overflow-x-auto border rounded-2xl">
          <table class="min-w-full">
            <thead className="bg-newgrey">
              <tr>
                <th class="px-4 py-4 text-left text-secondary1 w-1/4">Category Name</th>
                <th class="px-4 py-4 text-left text-secondary1 w-2/3">Category URL</th>
                <th class="px-4 py-4 text-center text-secondary1 w-1/12">Action</th>
              </tr>
            </thead>
            <tbody class="text-gray-700">
              {
                categories?.map((value, index) => (
                  <tr className={`border-b ${index === 0 ? 'border-t' : ''}`} key={value.id}>
                    <td className="px-4 py-4 text-black font-bold">{value.category_name}</td>
                    <td className="px-4 py-4 text-black font-bold">{
                      value.category_urls?.map((url, i) => (
                        <a key={i} href={url.category_url} target="_blank" className="text-blue">
                          {url.provider_name}
                        </a>
                      )).reduce((prev, curr) => [prev, ', ', curr])
                    }
                    </td>
                    <td className="px-4 py-4 text-secondary1 font-bold flex justify-center space-x-2">
                      {
                        value.is_subscribed ? 
                        <button className="text-red-500 px-4 py-2 rounded-md border border-red-500 hover:bg-red-500 hover:text-white"
                          onClick={() => handleUnsubscribe(value.category_name)}>Unsubscribe</button>
                         : 
                        <button className="text-green-500 px-4 py-2 rounded-md border border-green-500 hover:bg-green-500 hover:text-white"
                          onClick={() => handleSubscribe(value.category_name)}>Subscribe</button>
                      }
                    </td>
                  </tr>
                ))
              }
            </tbody>
          </table>
          
        </div>
      </div>

    </>
  )
}

export default LiveOTTCategory